<template>
  <v-card class="px-2 py-2 intern-expansion-panel" flat tile>
    <v-card class="d-flex justify-end mt-0" flat tile>
      <v-btn small class="px-2 white--text" color="grey darken-3" @click="handleAddCondition">
        Adicionar
        <v-icon class="ml-2" small>add</v-icon>
      </v-btn>
    </v-card>

    <div v-if="conditionRulesWrapper">
      <v-expansion-panels v-for="(condition, i) in conditions" :key="i" class="pt-2" hover multiple focusable tile>
        <v-expansion-panel>
          <v-expansion-panel-header class="pl-2 pr-0">
            <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">Condition-{{ i + 1 }}</span>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="py-2 px-2">
            <v-row class="mt-2 d-flex justify-space-between" no-gutters>
              <p class="text-subtitle-2 mb-0 grey--text text--darken-3">Regras para condição!</p>
              <v-icon color="grey darken-3" @click="handleAddRule(i)" small>add</v-icon>
            </v-row>

            <v-divider v-if="!conditions[i].fields.length" class="my-2" />

            <div v-if="conditionRulesContent" class="mb-2">
              <v-expansion-panels v-for="(item, index) in conditions[i].fields" :key="index" class="mt-2" hover multiple focusable tile>
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }" class="pl-2 pr-0">
                    <v-row no-gutters class="px-0 py-0">
                      <v-col cols="12" class="text--secondary">
                        <v-fade-transition leave-absolute>
                          <strong v-if="open">Defina as regras para condição!</strong>
                          <v-row v-else no-gutters style="width: 100%">
                            <v-col cols="12">
                              <strong>{{ item.field }}</strong>
                              "{{ item.operator }}"
                              <strong>{{ item.value }}</strong>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="px-2 pt-2 pb-3">
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end">
                        <v-icon color="red" @click="handleRemoveRule(item, i, index)" small>delete</v-icon>
                      </v-col>
                    </v-row>

                    <v-row justify="space-around" no-gutters>
                      <v-col cols="4">
                        <v-text-field label="Field" v-model="item.field" class="mr-2" hide-details />
                      </v-col>

                      <v-col cols="4">
                        <v-select
                          :items="operators"
                          v-model="item.operator"
                          label="Operator"
                          class="mr-2"
                          hide-details
                          append-icon="zmdi zmdi-chevron-down"
                        />
                      </v-col>

                      <v-col cols="4">
                        <v-text-field
                          label="Value"
                          v-model="item.value"
                          hide-details
                          append-icon="info"
                          @click:append="handleOpenMenuValueType($event, item, i, index)"
                        />

                        <v-menu transition="slide-y-transition" v-model="showMenu" bottom :position-x="x" :position-y="y">
                          <v-card class="px-3 py-1" flat tile>
                            <v-radio-group v-model="radioGroupType" @change="handleSetValueType" :mandatory="false" dense hide-details>
                              <v-radio label="String" value="string" />
                              <v-radio label="Number" value="number" />
                            </v-radio-group>
                          </v-card>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>

            <p class="text-subtitle-2 mb-0 grey--text text--darken-3">Hide actions:</p>
            <v-combobox
              v-model="conditions[i].hide.actions"
              :items="conditions[i].hide.actions"
              :search-input.sync="searchActions[i]"
              hide-selected
              label="Add some actions"
              multiple
              persistent-hint
              small-chips
              deletable-chips
              clearable
              dense
              append-icon="zmdi zmdi-chevron-down"
              class="mt-6 mb-3"
              hide-details
            >
              <template v-slot:no-data>
                <v-list-item dense>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "
                      <strong>{{ searchActions[i] }}</strong
                      >". Press <kbd>enter</kbd> to create a new one
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>

            <p class="text-subtitle-2 mb-0 grey--text text--darken-3">Hide fields:</p>
            <v-combobox
              v-model="conditions[i].hide.fields"
              :items="conditions[i].hide.fields"
              :search-input.sync="searchFields[i]"
              hide-selected
              label="Add some fields"
              multiple
              persistent-hint
              small-chips
              deletable-chips
              clearable
              dense
              append-icon="zmdi zmdi-chevron-down"
              class="mt-6 mb-3"
              hide-details
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "
                      <strong>{{ searchFields[i] }}</strong
                      >". Press <kbd>enter</kbd> to create a new one
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>

            <p class="text-subtitle-2 mb-0 grey--text text--darken-3">Readonly fields:</p>
            <v-combobox
              v-model="conditions[i].readonly.fields"
              :items="conditions[i].readonly.fields"
              :search-input.sync="searchFields[i]"
              hide-selected
              label="Add some fields"
              multiple
              persistent-hint
              small-chips
              deletable-chips
              clearable
              dense
              append-icon="zmdi zmdi-chevron-down"
              class="mt-6"
              hide-details
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      No results matching "
                      <strong>{{ searchFields[i] }}</strong
                      >". Press <kbd>enter</kbd> to create a new one
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>

            <v-row no-gutters class="mt-4">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn small class="white--text px-2" color="grey darken-3" @click="handleRemoveCondition(i)">
                  Deletar
                  <v-icon class="ml-2" small v-text="'delete'" />
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    conditions: { type: Array, default: () => [], required: true }
  },

  data: () => ({
    showMenu: false,
    searchFields: [],
    searchActions: [],
    conditionRulesContent: true,
    conditionRulesWrapper: true,
    operators: ['==', '!=', '>', '>=', '<', '<=', 'in', 'between', 'like', 'not in', 'not between', 'not like'],
    x: null,
    y: null,
    radioGroupType: 'string',
    currentParentIndex: null,
    currentChildIndex: null
  }),

  methods: {
    reloadComponentContent() {
      this.conditionRulesContent = false;

      this.$nextTick(() => (this.conditionRulesContent = true));
    },

    reloadComponentWrapper() {
      this.conditionRulesWrapper = false;

      this.$nextTick(() => (this.conditionRulesWrapper = true));
    },

    handleAddCondition() {
      let condition = {
        fields: [],
        hide: {
          actions: [],
          fields: []
        },
        readonly: {
          fields: []
        }
      };

      this.conditions.push(condition);

      this.reloadComponentWrapper();
    },

    handleRemoveCondition(parentIndex) {
      this.conditions.splice(parentIndex, 1);

      this.reloadComponentWrapper();
    },

    handleRemoveRule(item, parentIndex, childIndex) {
      this.conditions[parentIndex].fields.splice(childIndex, 1);

      this.reloadComponentContent();
    },

    handleAddRule(parentIndex) {
      let rule = {
        field: 'field',
        operator: '==',
        value: 'value'
      };

      this.conditions[parentIndex].fields.push(rule);

      this.reloadComponentContent();
    },

    handleOpenMenuValueType(e, item, parentIndex, childIndex) {
      this.x = e.x - 110;
      this.y = e.y + 10;

      this.showMenu = true;
      this.currentParentIndex = parentIndex;
      this.currentChildIndex = childIndex;
    },

    handleSetValueType() {
      const initialValue = this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value;

      if (this.radioGroupType === 'string') {
        this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value = this.conditions[this.currentParentIndex].fields[
          this.currentChildIndex
        ].value.toString();
      }

      if (this.radioGroupType === 'number') {
        this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value = parseInt(
          this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value
        );

        if (isNaN(parseInt(this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value))) {
          this.conditions[this.currentParentIndex].fields[this.currentChildIndex].value = initialValue;
        }
      }

      this.$nextTick(() => {
        this.currentParentIndex = null;
        this.currentChildIndex = null;
        this.radioGroupType = 'string';
      });
    }
  }
};
</script>

<style lang="scss">
.intern-expansion-panel {
  .v-expansion-panel-header {
    max-height: 48px;

    &.v-expansion-panel-header--active {
      max-height: 48px;
      min-height: 48px;
    }
  }

  .v-expansion-panel-content {
    .v-expansion-panel-content__wrap {
      /* padding-left: 8px;
      padding-right: 8px; */
      padding: 0;
    }
  }
}
</style>
